// extracted by mini-css-extract-plugin
module.exports = {"table-container":"CpmTable_table-container__3tUBt","table-row":"CpmTable_table-row__2brAt","table-item":"CpmTable_table-item__2i-8m","table":"CpmTable_table__1dgxV"};